const state={
        all:[
            {
                id:"1",
                tag:"貼紙",
                title:"慵懶的貓咪 - 野餐",
                describe:"人生志向是成為一隻貓咪",
                price:"60",
                img: './static/img/sticker_picnic.jpg',
                engtag:"sticker"
            },
            {
                id:"2",
                tag:"貼紙",
                title:"慵懶的貓咪 - 躺椅",
                describe:"人生志向是成為一隻貓咪",
                price:"60",
                img: '../static/img/sticker_beach.jpg',
                engtag:"sticker"
            },
            {
                id:"3",
                tag:"貼紙",
                title:"慵懶的貓咪 - 游泳",
                describe:"人生志向是成為一隻貓咪",
                price:"60",
                img: '../static/img/sticker_swimming.jpg',
                engtag:"sticker"
            },       
            {
                id:"4",
                tag:"貼紙",
                title:"慵懶的貓咪 - 抓屁屁",
                describe:"人生志向是成為一隻貓咪",
                price:"60",
                img: '../static/img/sticker_ass.jpg',
                engtag:"sticker"
            },
            {
                id:"5",
                tag:"年曆",
                title:"貓咪的一年",
                describe:"人生志向是成為一隻貓咪",
                price:"200",
                img: '../static/img/calendar_cat.jpg',
                engtag:"calendar"
            },
            {
                id:"6",
                tag:"年曆",
                title:"簡單是最難的",
                describe:"不是隨便 是簡約",
                price:"200",
                img: '../static/img/calendar_simple.jpg',
                engtag:"calendar"
            },
            {
                id:"7",
                tag:"明信片",
                title:"希望你一切都好",
                describe:"是我的願望",
                price:"60",
                img: '../static/img/postcard_loveyourself.jpg',
                engtag:"postcard"
            },
            {
                id:"8",
                tag:"明信片",
                title:"先好好愛自己",
                describe:"才有愛人的力氣",
                price:"60",
                img: '../static/img/postcard_hopeyouarewell.jpg',
                engtag:"postcard"
            },
            {
                id:"9",
                tag:"ZINE",
                title:"simple book",
                describe:"瑞秋的人生小誌",
                price:"60",
                img: '../static/img/zine_simplebook.png',
                engtag:"zine"
            },
            {
                id:"10",
                tag:"ZINE",
                title:"The ladys in me",
                describe:"瑞秋的人生小誌2",
                price:"60",
                img: '../static/img/zine_lady.jpg',
                engtag:"zine"
            },
        ]
}

// const getters = {
//     SearchProducts: state =>{
//         return state.all.filter(product.engtag = this.$route.params.name)
//     }
// }

export default {
    namespaced: true,
    state,
}


// WEBPACK FOOTER //
// ./src/store/modules/products.js